<template>
  <button v-if="!routerLink" @click="$emit('buttonClick')" :class="classes">
    <slot></slot>
  </button>
  <router-link v-else :to="routerLink" :class="classes">
    <slot></slot>
  </router-link>
</template>

<script>
/**
 * @name App Button
 * @description Can be a button element or a router-link.
 * @vue-prop {string|object} routerLink - vue router-link `:to` attribute. https://router.vuejs.org/api/#to
 * @vue-event {event} buttonClick - Emit click event
 * @example <app-button router-link="/">Go Home, Steve</app-button>
 */
export default {
  props: {
    routerLink: [String, Object]
  },
  data: () => ({
    classes:
      "button bg-primary text-btn-text font-bold py-2 px-4 border-none rounded"
  })
};
</script>
